/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2023
 * @format
 * @flow
 */

import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  themeObject: {
    palette: {
      type: 'light',
    },
    typography: {
      fontFamily: [
        'Poppins',
      ].join(','),
    },
  }
};

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    updateTheme: (state, action) => {
      state.themeObject = { ...state.themeObject, ...action.payload };
    }
  },
});

export const { updateTheme } = themeSlice.actions;

export default themeSlice.reducer;
